import { render, staticRenderFns } from "./AwardTable.vue?vue&type=template&id=53f58e52&scoped=true"
import script from "./AwardTable.vue?vue&type=script&lang=js"
export * from "./AwardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f58e52",
  null
  
)

export default component.exports